import P from 'components/P';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import React from 'react';

const PromotionGroupCard = ({ item }) => {
    return (
        <div style={{
            width: '100%',
            backgroundColor: 'white',
            borderRadius: '10px',
            padding: '15px',
            marginBottom: '10px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            position: 'relative'
        }}>
            <VerticalFlex gap={10}>
                <HorizontalFlex justify="space-between" align="center">
                    <P font={"Pretendard"} weight={700} size={16}>
                        {item.exhibitionName}
                    </P>
                    <div style={{
                        backgroundColor: 'var(--point-color)',
                        color: 'white',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        fontSize: '14px'
                    }}>
                        {item.discountRate}% 할인
                    </div>
                </HorizontalFlex>

                <P font={"Pretendard"} weight={400} size={14} color={"#666"}>
                    총 {item.products.length}개 상품
                </P>

                <HorizontalFlex justify="flex-end" align="center" gap={10}>
                    <P font={"Pretendard"} weight={400} size={14} color={"#999"} style={{ textDecoration: 'line-through' }}>
                        {item.totalOriginalPrice.toLocaleString()}원
                    </P>
                    <P font={"Pretendard"} weight={700} size={18} color={"var(--point-color)"}>
                        {item.totalPrice.toLocaleString()}원
                    </P>
                </HorizontalFlex>
            </VerticalFlex>
        </div>
    );
};

export default PromotionGroupCard;